module.exports = __webpack_public_path__ + "img/saudia-arabia.ca8fcd8d.png";